import { render, staticRenderFns } from "./CopyBooklistSlidebar.vue?vue&type=template&id=efafe080"
import script from "./CopyBooklistSlidebar.vue?vue&type=script&lang=js"
export * from "./CopyBooklistSlidebar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports